import { isPlatformBrowser } from '@angular/common';
import {
  DOCUMENT,
  Injectable,
  PLATFORM_ID,
  inject,
  signal
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NavigationStart, Router } from '@angular/router';

import { filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class UserSettingsMenuStateService {
  private readonly platformId = inject(PLATFORM_ID);
  private readonly document = inject(DOCUMENT);
  private readonly router = inject(Router);

  private readonly openSignal = signal(false);
  readonly isOpen = this.openSignal.asReadonly();

  constructor() {
    this.router.events
      .pipe(
        filter(
          (event): event is NavigationStart => event instanceof NavigationStart
        ),
        takeUntilDestroyed()
      )
      .subscribe(() => this.close());

    if (isPlatformBrowser(this.platformId)) {
      const view = this.document.defaultView;
      if (!view) {
        return;
      }

      const resetFromPageLifecycle = () => this.close();

      view.addEventListener('pagehide', resetFromPageLifecycle);
      view.addEventListener('pageshow', resetFromPageLifecycle);
      this.document.addEventListener('freeze', resetFromPageLifecycle);
      this.document.addEventListener('resume', resetFromPageLifecycle);
      this.document.addEventListener('visibilitychange', () => {
        if (
          this.document.visibilityState === 'hidden' ||
          this.document.visibilityState === 'visible'
        ) {
          resetFromPageLifecycle();
        }
      });
    }
  }

  setOpen(isOpen: boolean): void {
    this.openSignal.set(isOpen);
  }

  toggle(): void {
    this.openSignal.update((isOpen) => !isOpen);
  }

  close(): void {
    this.openSignal.set(false);
  }
}
